import { cn } from "@newxsystems/shared";
import { RavioliCommonContent } from "../../../../modules/content/components/RavioliCommonContent/RavioliCommonContent";
import { RavioliMedia } from "../../../../modules/content/components/RavioliMedia/RavioliMedia";
import { RavioliSection } from "../../../../modules/content/components/RavioliSection/RavioliSection";
import { VideoPlayer } from "../../../../modules/content/components/VideoPlayer/VideoPlayer";
import type { ITextMediaBlockProps } from "./TextMediaBlock.props";

export const TextMediaBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  direction,
  eyebrow,
  heading,
  image,
  parentClass,
  spacing,
  video,
}: ITextMediaBlockProps) => {
  const videoDestination =
    video?.source === "direct"
      ? video.directVideo
      : video?.source === "youtube"
        ? video.youtubeVideo
        : video?.vimeoVideo;
  const hasCopy = Boolean(eyebrow || heading || description || buttons?.length);
  if (!image && !videoDestination) return null;
  const media = (
    <div className="flex w-full min-w-0 flex-col gap-3">
      {image ? (
        <RavioliMedia
          aspectRatio={image.aspectRatio || "16:9"}
          media={image.image}
          sizes="(min-width: 768px) 50vw, 100vw"
        />
      ) : null}
      {video && videoDestination ? (
        <VideoPlayer
          banner={video.banner}
          directVideo={video.directVideo}
          source={video.source}
          vimeoVideo={video.vimeoVideo}
          youtubeVideo={video.youtubeVideo}
        />
      ) : null}
    </div>
  );
  return (
    <RavioliSection className={parentClass} id={anchorId} spacing={spacing}>
      {hasCopy ? (
        <div className="grid gap-6 md:grid-cols-2">
          <div
            className={cn(
              "order-1 flex min-w-0 items-center border border-primary bg-collection p-7 md:p-10 lg:p-12",
              direction === "ltr" && "md:order-2",
            )}
          >
            <RavioliCommonContent
              alignment={alignment}
              buttons={buttons}
              description={description}
              eyebrow={eyebrow}
              heading={heading}
            />
          </div>
          <div
            className={cn(
              "order-2 min-w-0",
              video && !image && "flex items-center",
              direction === "ltr" && "md:order-1",
            )}
          >
            {media}
          </div>
        </div>
      ) : (
        media
      )}
    </RavioliSection>
  );
};

TextMediaBlock.displayName = "Block::TextMediaBlock";
